export const version = '2.32.0';
//# sourceMappingURL=version.js.map